// extracted by mini-css-extract-plugin
export default {"form":"MoveDialogForm-module__form--uiB7e","autoComplete":"MoveDialogForm-module__autoComplete--jVd72"};